import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponseWithPagination, WhatsappOpeningMessageResponseData } from "schema"
import { z } from "zod"

type Response = DataResponseWithPagination<z.infer<typeof WhatsappOpeningMessageResponseData>>
type OnSuccessFn = (data: Response) => void

const getWhatsappOpeningMessageQueryKey = (id: string) => ["campaignsWhatsappOpeningMessages", id]

type Props = {
  id: string
  onSuccess?: OnSuccessFn
  enabled?: boolean
}

export const whatsappOpeningMessageQuery = ({ id, onSuccess, enabled = true }: Props) => {
  return queryOptions({
    queryKey: getWhatsappOpeningMessageQueryKey(id),
    queryFn: async () => {
      const { data } = await axios.get<Response>(`/integrations/whatsapp/opening-messages/${id}`)
      onSuccess?.(data)
      return data.data
    },
    enabled,
  })
}
